import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-187" data-mp="3kqnsmw4m036i">
      <div className="mx-auto max-w-5xl" data-id="element-188" data-mp="3ksgzocj4wpf1">
        <h2 className="text-center font-display text-[1.75rem] font-black leading-tight tracking-tight text-ink sm:text-[2.4rem]" data-id="element-189" data-mp="3fz5ndvvjzgfq">
          <span aria-hidden="true" data-id="element-190" data-mp="3azt0jb4om9d5">⭐ </span>Cosa dicono i professionisti
        </h2>
        <p className="mt-3 text-center text-sm font-medium text-ink/70" data-id="element-191" data-mp="3700qetzn3v5o">
          <span aria-hidden="true" data-id="element-192" data-mp="32063t2mwdrqf">⭐️⭐️⭐️⭐️⭐️</span> 4.9/5 · +1.200 professionisti soddisfatti
        </p>

        <div className="mx-auto mt-10 grid max-w-3xl gap-5 sm:grid-cols-2" data-id="element-193" data-mp="2x09x2vmtfm76">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl bg-sand p-6" data-id="element-194" data-mp="2s28h4jkos2zx">
              <div className="text-sm text-amber-500" aria-label="5 stelle su 5" data-id="element-195" data-mp="v9yex8b87p8o">
                <span aria-hidden="true" data-id="element-196" data-mp="qac0wwnkq4yt">★ ★ ★ ★ ★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-display text-sm italic leading-relaxed text-ink/85" data-id="element-197" data-mp="q8915kwmcxgw">
                &ldquo;{item.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6" data-id="element-198" data-mp="m6m73lf9gw7v">
                <p className="text-xs font-bold text-ink" data-id="element-199" data-mp="780k1q2xleah">{item.name}</p>
                <p className="text-xs text-ink/50" data-id="element-200" data-mp="79v83d9i1mis">{item.location}</p>
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-8 text-center text-[11px] text-ink/40" data-id="element-201" data-mp="zwppu2exm7sk">
          Testimonianze illustrative a scopo dimostrativo.
        </p>
      </div>
    </section>;
}